<template>
<div style="background-color:#e4e4e4" class="pa-1">
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="filteredGridRows"
    :search="search"
    class="elevation-1"
    dense
    fixed-header
    height="60vh"
    show-select
    :items-per-page="50"
    :footer-props="footerProps"
    :loading="loadTable"
    loading-text="Ачааллаж байна... Түр хүлээнэ үү!"
    no-data-text="Мэдээлэл байхгүй байна."
    no-results-text="Тохирох үр дүн олдсонгүй. Та дахин хайна уу?"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Хэрэглэгчийн жагсаалт</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-switch
          v-model="isActive"
          label="Идэвхитэй"
          color="success"
          :value="true"
          hide-details
        ></v-switch>
        <v-col cols="12" sm="3">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Хайлт"
            rounded
            filled
            background-color="blue lighten-5"
            clearable
            hide-details
          ></v-text-field>
        </v-col>


        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="green lighten-2"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              бүртгэх
              <v-icon small class="ml-1">mdi-plus-thick</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline green lighten-2" primary-title>
              {{ formTitle }}
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form">
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.lastname"
                      :rules="[required]"
                      label="Овог *"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.firstname"
                      :rules="[required]"
                      label="Нэр *"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Утас *"
                      :rules="[required]"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.email"
                      label="Имэйл *"
                      :rules="[required]"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.password"
                      label="Нууц үг *"
                      :rules="[required]"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.password_confirm"
                      label="Нууц үг баталгаажуулах *"
                      :rules="[required]"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <h4 style="color:red">* Заавал бөглөх талбар</h4>
                </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Цуцлах
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Хадгалах
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          persistent
          no-click-animation
          v-model="dialogDelete"
          width="500"
        >
          <template v-slot:activator="{ click }">
          <v-btn
            slot="activator"
            color="red lighten-2"
            dark
            class="mb-2 ml-2"
            @click="deleteItem"
          >
            Устгах
            <v-icon small class="ml-1">mdi-delete</v-icon>
          </v-btn>
          </template>
        
          <v-card>
            <v-card-title
              class="headline red lighten-2"
              primary-title
            >
              Мэдээллийг устгах уу?
            </v-card-title>
    
            <v-card-text>
              Сонгогдсон хэрэглэгчийн мэдээллийг устгахад итгэлтэй байна уу?
              <br>Дахин сэргээх боломжгүйг анхаарна уу.
            </v-card-text>
    
            <v-divider></v-divider>
    
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                text
                @click="closeDelete"
              >
                Үгүй
              </v-btn>
              <v-btn
                color="primary darken-1"
                text
                @click="deleteItemConfirm"
              >
                Тийм
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-toolbar>
    </template>

    <template v-slot:header="{ header }">
      <tr class="grey lighten-3">
        <th style="border-right: 1px solid #c8c8c8">
          <v-icon>mdi-filter-variant</v-icon>
				</th>
        <th style="border-right: 1px solid #c8c8c8" v-for="header in headers" :key="header.text">
          <div v-if="filters.hasOwnProperty(header.value)">
            <v-autocomplete
              flat
              hide-details
              multiple
              attach
              chips
              dense
              clearable
              :items="columnValueList(header.value)"
              v-model="filters[header.value]"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 5">
                  <span> 
                    {{ item }} 
                  </span>
                </v-chip>
                <span v-if="index === 5" class="grey--text caption" > 
                  (+{{ filters[header.value].length - 5 }} others) 
                </span>
              </template>
            </v-autocomplete>
          </div>
          <div v-if="!filters.hasOwnProperty(header.value)">
            <v-icon>mdi-filter-variant</v-icon>
          </div>
        </th>
      </tr>
    </template>
 
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
    <template v-slot:item.salary="{ item }">
      <span>{{formatPrice(item.salary)}}</span>
    </template>
    <template v-slot:item.created_at="{ item }">
      <span>{{ formatDate(item.created_at) }}</span>
    </template>
    <template v-slot:item.no = "{ index }">
      {{ index + 1 }}
    </template>
    <template v-slot:no-data>
    </template>
  </v-data-table>
</div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';
  
  let bgColorCode = "orange lighten-5";
  export default {
    data: () => ({
      footerProps: {'items-per-page-options': [10, 20, 50, 100, -1]},
      pagination: {
        sortBy: 'name'
      },
      date: new Date().toISOString().substr(0, 10),
      menu2: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      selected: [],
      loadTable: true,
      isActive: true,
      headers: [
        {
          text: '№',
          align: 'start',
          sortable: false,
          value: 'no',
          divider: true, 
          class: bgColorCode
        },
        { text: 'UserID', value: 'id', divider: true, class: bgColorCode },
        { text: 'Овог', value: 'lastname', divider: true, class: bgColorCode },
        { text: 'Нэр', value: 'firstname', divider: true, class: bgColorCode },
        { text: 'Утас', value: 'phone', divider: true, class: bgColorCode },
        { text: 'Имэйл', value: 'email', divider: true, class: bgColorCode },
        { text: 'Status', value: 'status', divider: true, class: bgColorCode },
        { text: 'Хүчинтэй огноо', value: 'valid_dt', divider: true, class: bgColorCode },
        { text: 'Бүртгүүлсэн огноо', value: 'created_at', divider: true, class: bgColorCode },
        { text: 'Үйлдэл', value: 'actions', sortable: false, divider: false, class: bgColorCode },
      ],
      filters: {
        id: [],
        lastname: [],
				firstname: [],
				phone: [],
				email: [],
				status: [],
				valid_dt: [],
        created_at: [],
			},
      gridRows: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        lastname: '',
        firstname: '',
        phone: '',
        email: '',
        password: '',
        password_confirm: '',
      },
      defaultItem: {
        id: '',
        lastname: '',
        firstname: '',
        phone: '',
        email: '',
        password: '',
        password_confirm: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Шинээр бүртгэх' : 'Засварлах'
      },
      filteredGridRows() {
				return this.gridRows.filter((d) => {
					return Object.keys(this.filters).every((f) => {
						// return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
						return (this.filters[f].length < 1 || this.filters[f].includes(d[f])) && this.isActive ? (d.status == 'active') : true;
					});
				});
			},
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        axios.get('users')
          .then(response => {
            this.gridRows = response.data;
            this.loadTable = false;
          })
          .catch(error => {
            console.log(error)
          })
      },

      required(value) {
        if (value instanceof Array && value.length == 0) {
          return 'Заавал утга оруулна уу.';
        }
        return !!value || 'Заавал утга оруулна уу.';
      },

      formatPrice(value) {
        return value == null || value == "0" ? "-" : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      formatDate(dt) {
        return moment(dt).format('YYYY-MM-DD hh:mm:ss')
      },

      columnValueList(val) {
				return this.gridRows.map((d) => d[val]);
			},

      editItem (item) {
        this.editedIndex = this.gridRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        if (this.selected.length == 0) {
          alert('Устгах мэдээллийг сонгоно уу.')
          return
        }
        this.editedIndex = this.gridRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        let ids = [];
        this.selected.forEach(function (e) {
            ids.push(e.id);
        });

        axios.delete('userid/' + ids)
          .then(response => {
            alert('Сонгогдсон мэдээллийг амжилттай устгалаа.');
            this.reloadMain()
            this.closeDelete()
          })
          .catch(error => {
            alert('Сонгогдсон мэдээллийг устгахад алдаа гарлаа.');
            console.log(error)
          })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (this.editedItem.password != this.editedItem.password_confirm) {
          alert('Нууц үг хоорондоо тохирохгүй байна. Дахин оруулна уу.');
          return;
        }
        if (this.editedIndex > -1) {
          axios.put('userid/' + this.gridRows[this.editedIndex].id, this.editedItem)
            .then(response => {
              alert('Мэдээлэл амжилттай засагдлаа.');
              this.reloadMain();
              // console.log(JSON.stringify(response.data));
            })
            .catch(error => {
              alert('Мэдээлэл засварлахад алдаа гарлаа.');
              console.log(error)
            })
          // Object.assign(this.gridRows[this.editedIndex], this.editedItem)
        } else {
          axios.post('userid/store', this.editedItem)
            .then(response => {
              alert('Мэдээлэл амжилттай орууллаа.');
              this.reloadMain();
              // console.log(JSON.stringify(response.data));
            })
            .catch(error => {
              alert('Мэдээлэл оруулахад алдаа гарлаа.');
              console.log(error)
            })
          //this.gridRows.push(this.editedItem)
        }
        this.close()
      },
      
      reloadMain() {
        this.initialize();
      },

    },
  }
</script>